import { PortMessage } from '../../../../../types/PortMessage';
import { queries } from '../../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../../common/hooks/usePaginationQuery';

export const usePortPagination = (page: number, searchQuery: string) => {
    const nextPage = queries.ports.pagination({ page: page + 1, searchQuery });

    return usePaginationQuery<PortMessage>({
        ...queries.ports.pagination({ page, searchQuery }),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
